import { PeriodProvider } from "@/providers/Period";
import { MonitorIcon } from "@phosphor-icons/react";
import { lazy } from "react";

const PainelNotaFiscal = lazy(() => import("./PainelNotaFiscal"));
const PainelPedidos = lazy(() => import("./PainelPedidos"));
const RelatorioPainelExpedicao = lazy(() => import("./RelatorioPainelExpedicao").then((m) => ({ default: m.RelatorioPainelExpedicao })));
const PainelDePedidos = lazy(() => import("./PainelDePedidos"));
const PainelRotas = lazy(() => import("./PainelRotas"));
const PainelEmbarque = lazy(() => import("./PainelEmbarque"));
const PainelProdutividadeAbastecimento = lazy(() => import("./PainelProdutividade/Abastecimento"));
const PainelProdutividadeExpedicao = lazy(() => import("./PainelProdutividade/Expedicao"));
const PainelProdutividadeMovimentacao = lazy(() => import("./PainelProdutividade/Movimentacao"));
const PainelProdutividadeRecebimento = lazy(() => import("./PainelProdutividade/Recebimento"));
const PainelProdutividadeSeparacao = lazy(() => import("./PainelProdutividade/Separacao"));

const ModulePainel = {
  menuItem: {
    to: "/painel",
    title: "Painel",
    icon: MonitorIcon,
    id: 14,
    childrens: [
      {
        to: "/painel/painel-nota-fiscal",
        title: "Operador Logistico",
        fullTitle: "Painel Operador Logistico",
        id: 70,
      },
      {
        to: "/painel/painel-pedido",
        title: "Pedidos",
        fullTitle: "Pedidos",
        id: 71,
      },
      {
        to: "/painel/painel-de-pedidos",
        title: "Painel de Pedidos",
        fullTitle: "Painel de Pedidos",
        id: 72,
      },
      {
        to: "/painel/relatorio-painel-expedicao",
        title: "Expedição",
        fullTitle: "Painel Expedição",
        id: 73,
      },
      {
        to: "/painel/painel-rotas",
        title: "Painel de Rotas",
        fullTitle: "Painel de Rotas",
        id: 74,
      },
      {
        to: "/painel/painel-embarque",
        title: "Painel de Embarque",
        fullTitle: "Painel de Embarque",
        id: 75,
      },
      {
        to: "/painel/painel-de-produtividade-abastecimento",
        title: "Painel de Produtividade",
        fullTitle: "Painel de Produtividade",
        id: 76,
      },
    ],
  },

  routes: [
    {
      path: "painel/painel-nota-fiscal",
      element: (
        <PeriodProvider>
          <PainelNotaFiscal />
        </PeriodProvider>
      ),
    },
    {
      path: "painel/painel-pedido",
      element: <PainelPedidos />,
    },
    {
      path: "painel/painel-de-pedidos",
      element: <PainelDePedidos />,
    },
    {
      path: "/painel/relatorio-painel-expedicao",
      element: <RelatorioPainelExpedicao />,
    },
    {
      path: "/painel/painel-rotas",
      element: <PainelRotas />,
    },
    {
      path: "/painel/painel-embarque",
      element: <PainelEmbarque />,
    },
    {
      path: "/painel/painel-de-produtividade-abastecimento",
      element: <PainelProdutividadeAbastecimento />,
    },
    {
      path: "/painel/painel-de-produtividade-expedicao",
      element: <PainelProdutividadeExpedicao />,
    },
    {
      path: "/painel/painel-de-produtividade-movimentacao",
      element: <PainelProdutividadeMovimentacao />,
    },
    {
      path: "/painel/painel-de-produtividade-recebimento",
      element: <PainelProdutividadeRecebimento />,
    },
    {
      path: "/painel/painel-de-produtividade-separacao",
      element: <PainelProdutividadeSeparacao />,
    },
  ],
};

export default ModulePainel;
